module.exports = __webpack_public_path__ + "img/WM ONLINE.38194e5d.png";